module.exports = __webpack_public_path__ + "img/curved10.804fd6c6.jpg";